// extracted by mini-css-extract-plugin
export default {"timings":"otCBV0gl","time":"JwnFQEOd"};